import { usePage } from "@inertiajs/react";
import { includes } from "lodash";
import { getSelectorsByUserAgent } from "react-device-detect";

export const ENV_STG = 'staging';
export const ENV_PROD = 'production';
export const GA_STG_MEASUREMENT_ID = 'G-R8ZNTBSNZW';
export const GA_PROD_MEASUREMENT_ID = 'G-FHHEZRFNK8';

export const USER_HOMEPAGE_COMPONENT = 'Top/Index';

export const MAX_UPLOAD_FILE_SIZE = 2097152; //2MB convert to byte
export const HEADER_HEIGHT = 20;

/** Constant Primary Type **/
export const MAX_STRING_LENGTH = 255;
export const INT_MAX_VALUE = 2147483647;
export const MEDIUM_INT_MAX_VALUE = 8388607;
export const SMALL_INT_MAX_VALUE = 32767;
export const ZERO_NUMBER = 0;

export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 4096;

export const USER_COMPANY_TYPE = 1;

/** NOTIFICATION CONSTANTS */
export const NOTIFICATION_IMPORTANT = 1;
export const NOTIFICATION_NEW = 2;

/** ADDRESS - LOCATION **/
export const ZIPCODE_LENGTH = 7;

/** CONVERSATION */
export const CONVERSATION_PAGE_SIZE = 20;

export function number_format(number) {
    return new Intl.NumberFormat('ja-JP').format(number);
}

export function scrollToErrorForm(classErrorName) {
    if (document.getElementsByClassName(classErrorName).length) {
        window.scrollTo({
            top: document.getElementsByClassName(classErrorName)[0].closest('div').offsetTop - (HEADER_HEIGHT + 10), // have space 10px after header
            behavior: "smooth"
        });
    }
}

export const formatZipcode = (value) =>
    value.replace(/\D/g, '').replace(/(\d{3})(\d{4})/, '$1-$2');

/** SORTABLE TABLE */
export const getClassNameHeaderSortIcon = (canSort = true, isSorted = false, isSortedDesc = false) => {
    if (canSort) {
        let className = 'relative '
            + 'before:absolute before:content-["▲"/""] before:bottom-1/2 before:right-2 before:text-[0.8rem] before:leading-[9px] before:pb-0.5 '
            + ' after:absolute after:content-["▼"/""] after:top-1/2 after:right-2 after:text-[0.8rem] after:leading-[9px] after:pb-0.5 ';

        if (isSorted) {
            className += isSortedDesc ? 'before:opacity-20' : 'after:opacity-20';
        } else {
            className += 'before:opacity-20 '
                + 'after:opacity-20';
        }

        return className;
    } else {
        return '';
    }
};

/** Check allowed image extensions **/
export const checkAllowedImageExtensions = (ext) => {
    return includes(['jpg', 'png'], ext.toLowerCase());
};

/** Check allowed file content type  **/
export const checkAllowedFileContentType = async (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const arrayBuffer = reader.result;
            const uint8Array = new Uint8Array(arrayBuffer);

            const magicNumber = uint8Array.slice(0, 4).reduce((acc, byte) => acc + byte.toString(16).padStart(2, '0'), '');
            let actualType = '';
            switch (magicNumber) {
                case '89504e47':
                    actualType = 'image/png';
                    break;
                case 'ffd8ffe0':
                    actualType = 'image/jpeg';
                    break;
                default:
                    actualType = 'unknown';
            }
            resolve(actualType === file.type);
        };

        reader.readAsArrayBuffer(file);
    });
};


/**** Check Server And Client Side ****/
export const isClient = typeof window !== 'undefined';

export const detectDevice = () => {
    const { user_agent } = usePage().props;

    return getSelectorsByUserAgent(user_agent);
};

export const getJapaneseDayOfWeek = (dayOfWeek) => {
    switch (dayOfWeek) {
        case 1:
            return '月曜日';
        case 2:
            return '火曜日';
        case 3:
            return '水曜日';
        case 4:
            return '木曜日';
        case 5:
            return '金曜日';
        case 6:
            return '土曜日';
        default:
            return '日曜日';
    }
};

export const showErrorAlert = () => {
    alert("エラーが発生しました\n時間を置いてもう一度お試しください。");
};
